import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/correspondencia/vigilantes";

export const CorrespondenciaVigilanteService = {
  getPendientes: () => {
    return axiosInstance.get(`${BASE_URL}/pendientes/`);
  },

  getHistorial: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/historial/`, { params });
  },

  getDetalle: (slug) => {
    return axiosInstance.get(`${BASE_URL}/${slug}/`);
  },

  marcarRecogido: (slug, data) => {
    return axiosInstance.patch(`${BASE_URL}/${slug}/`, data);
  },
};

export default CorrespondenciaVigilanteService;
